import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HandsetService } from '../../../core/services/handset.service';
import { ToolbarService } from '../../../core/services/toolbar.service';
import { Offers } from '../../models/offers';
import { OffersService } from '../../services/offers.service';

@Component({
standalone: false,
  selector: 'app-offers',
  styleUrls: ['./offers.component.scss'],
  templateUrl: './offers.component.html',
})
export class OffersComponent implements OnInit {
  public offers: Observable<Offers>;

  constructor(
    private route: ActivatedRoute,
    private toolbar: ToolbarService,
    public router: Router,
    public handsetService: HandsetService,
    private offersService: OffersService,
  ) {
    this.toolbar.init(this.route);
  }

  public ngOnInit(): void {
    this.offers = this.offersService.loadOffers();
  }
}
